import { InputProps } from "types/dom";

export default function NumberOnlyInput (props: InputProps) {
  return <input
    type="number"
    onKeyDown={e => {
      if (!/[0-9]/.test(e.key) && !([ "Backspace", "Enter", "Tab" ].includes(e.key))) {
        e.preventDefault();
      }
    }}
    {...props}
  />;
}